import React from 'react';
import moment from 'moment';

const TemperatureStatus = ({show, temperature, style, goToReview, vehicleDevice}) => {
    if (!show) {
        return null;
    }

    const item_class_name = style.item_class_name || 'md-status-bar-item';

    let temperature_result = '--';
    let color_class = 'c-black';
    let deviceId = (vehicleDevice && vehicleDevice.device_id) ? vehicleDevice.device_id : 'Nenhum sensor associado';
    let title = `Sensor: ${deviceId}`;
    let temperature_value = temperature.temperature || null;

    const updated_at = moment(temperature.datetime);
    const now = moment();

    const diff = now.diff(updated_at, 'days');

    if (diff >= 1) {
        title += '\n Há mais de um dia sem receber temperatura.';
        temperature_value = null;
    }

    if (temperature_value) {
        temperature_result = temperature_value;

        if(temperature_value < 1) {
            color_class = 'c-red';
        } else if (temperature_value > 1 && temperature_value <= 3) {
            color_class = 'c-orange';
        } else if (temperature_value > 3 && temperature_value <= 6) {
            color_class = 'c-green';
        } else if (temperature_value > 6 && temperature_value <= 10) {
            color_class = 'c-orange';
        }
    }

    const onClick = e => {
        if (goToReview) {
            window.location.hash = `temperature?vehicle_id=${temperature.id}`;
        }
    }

    return (
        <div className={`${color_class} ${item_class_name}`} style={{cursor: 'pointer'}} title={title} onClick={onClick}>
            <i className="fa fa-thermometer-three-quarters"></i> {temperature_result}º
        </div>
    );

}

TemperatureStatus.defaultProps = {
    show: true,
    temperature: { temperature: null },
    style: {},
    goToReview: false
};

export default TemperatureStatus;



// WEBPACK FOOTER //
// ./src/components/Status/Temperature.js